<div class="header">
  <div class="logo pull-left">
    <a href="https://dashboard.customerheartbeat.com/"
      ><img src="assets/images/img-logo-integron-small.png"
    /></a>
  </div>
</div>

<div class="main-container" id="main-container">
  <div class="main-content">
    <div class="limiter">
      <div
        class="container-login100"
        style="background-image: url(&quot;/assets/images/bg-login.jpg&quot;)"
      >
        <div class="wrap-login100">
          <!-- Reset password form -->
          <form
            *ngIf="mode === 'resetPassword' && !success"
            class="login100-form validate-form"
            (ngSubmit)="onSubmit()"
            #resetForm="ngForm"
          >
            <span class="login100-form-logo-wrap">
              <img
                src="assets/images/img-logo-chb-KTO.png"
                style="margin-left: auto; margin-right: auto"
              />
            </span>

            <div
              class="text-small"
              style="text-align: center; margin-bottom: 15px"
            >
              Choose a new password
            </div>

            <div class="wrap-input100">
              <input
                class="input100"
                type="password"
                id="password"
                name="password"
                placeholder="New password"
                required
                [minlength]="minLength"
                [ngModel]="model.password"
                (ngModelChange)="onPasswordChanged($event)"
              />
            </div>

            <div *ngIf="model.password.length > 0">
              <div *ngFor="let item of checklist">
                <fa-icon
                  [icon]="['fas', 'check']"
                  style="color: #69bb95 !important"
                  *ngIf="rules[item.rule]"
                ></fa-icon>
                <fa-icon
                  [icon]="['fas', 'times']"
                  style="color: #be163c !important"
                  *ngIf="!rules[item.rule]"
                ></fa-icon>
                {{ item.label }}
              </div>
            </div>

            <div class="wrap-input100">
              <input
                class="input100"
                type="password"
                id="confirm"
                name="confirm"
                placeholder="Confirm new password"
                required
                [(ngModel)]="model.confirm"
                #confirm="ngModel"
              />

              <div
                [hidden]="confirm.valid || confirm.pristine"
                class="alert alert-danger"
              >
                Please confirm your password
              </div>
            </div>

            <div *ngIf="errorMessage" class="alert alert-danger">
              {{ errorMessage }}
            </div>

            <div class="container-login100-form-btn">
              <button
                class="login100-form-btn"
                type="submit"
                [disabled]="
                  !resetForm.form.valid || !passwordValid || submitting
                "
              >
                {{ submitting ? "Saving..." : "Set new password" }}
              </button>
            </div>

            <div class="text-small login-footer">
              <br />
              Intelligence Dashboard is a product of Integron B.V.<br />
              All rights reserved
            </div>
          </form>

          <!-- Verify email / recover email -->
          <div
            *ngIf="
              (mode === 'verifyEmail' || mode === 'recoverEmail') && !success
            "
            class="login100-form"
          >
            <span class="login100-form-logo-wrap">
              <img
                src="assets/images/img-logo-chb-KTO.png"
                style="margin-left: auto; margin-right: auto"
              />
            </span>

            <div class="text-small" style="text-align: center; margin: 20px 0">
              <span *ngIf="mode === 'verifyEmail'">
                Confirm your email address to finish setting up your account.
              </span>
              <span *ngIf="mode === 'recoverEmail'">
                Restore your account's original email address.
              </span>
            </div>

            <div *ngIf="errorMessage" class="alert alert-danger">
              {{ errorMessage }}
            </div>

            <div class="container-login100-form-btn">
              <button
                class="login100-form-btn"
                type="button"
                [disabled]="submitting"
                (click)="onApply()"
              >
                {{
                  submitting
                    ? "Please wait..."
                    : mode === "recoverEmail"
                      ? "Restore my email address"
                      : "Verify my email address"
                }}
              </button>
            </div>
          </div>

          <!-- Success -->
          <div *ngIf="success" class="login100-form">
            <span class="login100-form-logo-wrap">
              <img
                src="assets/images/img-logo-chb-KTO.png"
                style="margin-left: auto; margin-right: auto"
              />
            </span>

            <div class="alert alert-success" style="margin-top: 20px">
              {{ successMessage }}
            </div>

            <div class="container-login100-form-btn">
              <button
                class="login100-form-btn"
                type="button"
                (click)="goToLogin()"
              >
                Go to login
              </button>
            </div>
          </div>

          <!-- Unsupported / malformed link -->
          <div *ngIf="unsupported" class="login100-form">
            <span class="login100-form-logo-wrap">
              <img
                src="assets/images/img-logo-chb-KTO.png"
                style="margin-left: auto; margin-right: auto"
              />
            </span>

            <div class="alert alert-danger" style="margin-top: 20px">
              This link is not supported or is missing required information.
              Please request a new email and try again.
            </div>

            <div class="container-login100-form-btn">
              <button
                class="login100-form-btn"
                type="button"
                (click)="goToLogin()"
              >
                Go to login
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
